// extracted by mini-css-extract-plugin
module.exports = {"wrp":"HomeProducts_wrp__2ZE2r","secondaryText":"HomeProducts_secondaryText__3VW5X","mainText":"HomeProducts_mainText__3Y3zU","productsWrp":"HomeProducts_productsWrp__3590f"};